import { ApolloClient } from '@apollo/client'
import create from 'zustand'
import { FETCH_CARD } from '../../graphql/queries'

type DoctorCardValues = {
  doctorCard?: {
    thumb: string
    name: string
    crm: string
    company: string
  }
  loading: boolean
}

type DoctorCardActions = {
  loadDoctorCard: (client: ApolloClient<unknown>) => void
}

export type DoctorCardState = DoctorCardValues & DoctorCardActions

const initialState: DoctorCardValues = {
  loading: false
}

export const useDoctorCard = create<DoctorCardState>(set => ({
  ...initialState,
  loadDoctorCard: async client => {
    set({ loading: true })
    const { data } = await client.query({
      query: FETCH_CARD,
      fetchPolicy: 'network-only'
    })
    set({
      loading: false,
      doctorCard: data?.currentWorkspace
    })
  }
}))
